import React from 'react'
import { useStyles } from './styles'
import { Box, Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'

export const BackdropSection = ({ customStyle, text }) => {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)
    return (
        <Box className={classes.mapBlur} style={customStyle}>
            <Typography>{locale.locations.dragAndDropMsg}</Typography>
        </Box>
    )
}
